import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { UpdateD2PStatusRequest, UpdateD2PStatusResponse } from '@onefootprint/types';
import { AUTH_HEADER } from '@onefootprint/types';
import { useMutation } from '@tanstack/react-query';
const updateD2PStatus = async ({
  authToken,
  ...payload
}: UpdateD2PStatusRequest) => {
  const response = await request<UpdateD2PStatusResponse>({
    method: 'POST',
    url: '/hosted/onboarding/d2p/status',
    data: payload,
    headers: {
      [AUTH_HEADER]: authToken
    }
  });
  return response.data;
};
const useUpdateD2PStatus = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: updateD2PStatus
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useUpdateD2PStatus;